/* eslint-disable camelcase */
export interface OrganizationTrackingData {
  account_id: number | null;
  organization_id: number | null;
  site_id?: number | null;
}

export enum Event {
  CLICK_NEW_SITE = 'Create new site',
  CLICK_NEW_ORGANIZATION = 'Create new organization',
  CLICK_ORGINZATION_SETTINGS = 'Open organization settigns dropdown',
  CLICK_SITE_SETTINGS = 'Site settings icon',
  CLICK_CHANGE_PLAN = 'Change plan button',
  CLICK_INVITE_PEOPLE = 'Invite people menu item',
  CLICK_EDIT_ORGANIZATION = 'Edit organization menu item',
  VIEW_EDIT_ORGANIZATION_MODAL = 'Edit organization modal',
  CONFIRM_EDIT_ORGANIZATION_MODAL = 'Edit organization modal confirm button',
  CLICK_TRANSFER_OWNERSHIP = 'Transfer ownership menu item',
  VIEW_TRANSFER_OWNERSHIP_MODAL = 'Transfer ownership modal',
  CONFIRM_TRANSFER_OWNERSHIP_MODAL = 'Transfer ownership modal confirm button',
  CLICK_DELETE_ORGANIZATION = 'Delete organization menu item',
  VIEW_DELETE_ORGANIZATION_MODAL = 'Delete organization modal',
  CONFIRM_DELETE_ORGANIZATION_MODAL = 'Delete organization modal confirm button',
  CLICK_TRANSFER_SITE = 'Transfer site icon',
  VIEW_TRANSFER_SITE_MODAL = 'Transfer site modal',
  CONFIRM_TRANSFER_SITE_MODAL = 'Transfer site modal confirm button',
  CLICK_DELETE_SITE = 'Delete site icon',
  VIEW_DELETE_SITE_MODAL = 'Delete site modal',
  CONFIRM_DELETE_SITE_MODAL = 'Delete site modal confirm button',
  CLICK_VIEW_TRACKING_CODE = 'View tracking code',
  CLICK_INSTALL_TRACKING_CODE = 'Install tracking code',
  FILTERED_LIST = 'Filtered sites and organizations',
  NAVIGATE_TO_DASHBOARD_OVERVIEW = 'Navigate to dashboard overview',
}

export enum UiPosition {
  HEADER = 'Header',
  SEARCH_BAR = 'Search bar',
  ORGANIZATION = 'Organization',
  ORGANIZATION_SETTINGS_MENU = 'Organizations settings menu',
  SITE_ITEM = 'Site item',
  PLAN_TAG = 'Plan tag',
  PLAN_BUTTON = 'Change plan button',
  EDIT_ORGANIZATION_MODAL = 'Edit organization modal',
  TRANSFER_OWNERSHIP_MODAL = 'Transfer ownership modal',
  DELETE_ORGANIZATION_MODAL = 'Delete organization modal',
  TRANSFER_SITE_MODAL = 'Transfer site modal',
  DELETE_SITE_MODAL = 'Delete site modal',
}
